// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tag_tag__T2Wjc {
    display: inline-flex;
    position: relative;
    align-items: center;
    gap: 4px;
    line-height: 1.5em;
    border-radius: 4px;
    padding: 2px 8px;
    margin: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Tag/Tag.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".tag {\n    display: inline-flex;\n    position: relative;\n    align-items: center;\n    gap: 4px;\n    line-height: 1.5em;\n    border-radius: 4px;\n    padding: 2px 8px;\n    margin: 0;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tag": `Tag_tag__T2Wjc`
};
export default ___CSS_LOADER_EXPORT___;
